<template>
  <v-container v-if="modoVisualizacao === 'grid'" grid-list-md text-xs-center class="py-4 mx-auto px-2">
    <v-layout row wrap justify-start class="px-4 pb-4 mb-4">
      <v-flex v-for="(prefeitura, index) in itens" :key="index" xs12 sm6 md6 lg6 class="pa-2">
        <v-card height="100%">
          <v-card-text class="align-center justify-start" style="display: flex;">
            <v-tooltip top>
              <v-checkbox slot="activator" v-model="prefeitura.integracaoIPMAtiva"
                          class="mx-0 px-0" style="max-width: 30px" :ripple="false"
                          @change="$emit('atualizarOrgao', prefeitura)"/>
              <span v-if="!prefeitura.integracaoIPMAtiva">
                Ativar Integração
              </span>
              <span v-else>
                Desativar Integração
              </span>
            </v-tooltip>
            {{prefeitura.nome}} - {{prefeitura.sigla}}
            <v-icon class="mx-0 px-0" style="max-width: 30px"></v-icon>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <az-container v-else>
      <az-form>
          <div class="tabela-prefeituras">
              <v-data-table :headers="colunas" :items="itens"
                            no-data-text="Nenhum usuário encontrado"
                            class="tabela-usuarios" hide-actions>
                  <template slot="items" slot-scope="props">
                    <td class="my-4">{{ props.item.nome }} - {{props.item.sigla}}</td>
                      <td>
                        <span v-if="props.item.integracaoIPMAtiva">
                          Ativa
                        </span>
                        <span v-else>
                          Desativada
                        </span>
                      </td>
                      <td class="table-actions">
                          <v-tooltip top class="no-mobile" v-az-auth="'Usuario.Visualizar'">
                              <a slot="activator" @click="$emit('visualizar', props.item.usuario.id)">
                                  <v-icon v-if="!props.item.integracaoIPMAtiva" @click="toggleIntegracao(props.item)">radio_button_unchecked</v-icon>
                                  <v-icon v-else :color="$vuetify.theme.primary" @click="toggleIntegracao(props.item)">radio_button_checked</v-icon>
                              </a>
                              <span v-if="props.item.integracaoIPMAtiva">
                                Desativar
                              </span>
                              <span v-else>
                                Ativar
                              </span>
                          </v-tooltip>
                      </td>
                  </template>
              </v-data-table>
          </div>
      </az-form>
  </az-container>
</template>

<script>
export default {
  name: 'PrefeiturasTabela',
  props: ['itens', 'modoVisualizacao'],
  data() {
    return {
      loadingPrefeituras: false,
      colunas: [
        {
          text: 'Prefeitura',
          align: 'left',
          sortable: false,
          width: '60%',
          class: 'primary--text'
        },
        {
          text: 'Situação Integração',
          sortable: false,
          align: 'left',
          width: '60%',
          class: 'primary--text'
        },
        {
          text: 'Ativar/Desativar',
          align: 'right',
          sortable: false,
          class: 'primary--text'
        }
      ]
    }
  },
  methods:{
    toggleIntegracao(prefeitura){
      prefeitura.integracaoIPMAtiva = !prefeitura.integracaoIPMAtiva
      this.$emit('atualizarOrgao', prefeitura)
    }
  }
}
</script>

<style lang="stylus">
    .az-comissoes
        .v-chip .v-chip__content
            height: 20px !important;

        .v-chip
            margin: 5px 10px 5px 0 !important;
            padding: 3px 0
            color: #7f7f7f !important

    @media (max-width: 720px)
        .tabela-usuarios
            td:nth-of-type(1):before
                content: "Usuário:"

            td:nth-of-type(2):before
                content: "E-mail:"

            td:nth-of-type(3)
                span
                    width 100%

            td:nth-of-type(3):before
                content: "Comissões:"

            td:nth-of-type(4):before
                content: "Situação:"

            .table-actions
                display none !important

    .tabela-prefeituras
      tbody tr
        border-bottom: 1px solid #e9e9e9 !important

        td
          height: 40px
          color: #777777
          font-size: 16px !important
          padding: 0 25px !important
</style>
